export enum ZIndex {
  BlockingScreen = 5,
  Header = 6,
  SideBar = 6,
  ModalWindow = 7,
  Alert = 8,
}
